module.exports = __webpack_public_path__ + "static/media/smallMotorbike.def28d1d.png";